<script setup lang="ts">
import type { Order } from "@/schemas/order";

defineProps<{ order: Order }>();
</script>

<template>
  <UiDefaultPage :title="`Commande #${order.order_id}`">
    <div class="space-y-8">
      <p>La commande <em>#{{ order.order_id }}</em> a été passée le <em>{{ date(order.timestamp) }}</em> et est actuellement <strong>{{ order.status }}</strong></p>
      <h2 class="h2 text-primary">
        Détails de la commande
      </h2>
      <OrderItems :items="order.items" />
      <OrderTotals :totals="order.totals" class="ml-auto" />
      <OrderCustomer :order="order" />
    </div>
  </UiDefaultPage>
</template>
